import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Container, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '../MoneyLogHistory'

const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);
  const _wallet = useRef(state.filter.wallet);
  const [wallet, setWallet] = useState(state.filter.wallet);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeWallet = useCallback((payload) => {
    _wallet.current = payload.target.value
    setWallet(_wallet.current)
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current,
        wallet: _wallet.current
      }
    })
  }, [dispatch])

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col className='align-self-center'>
            <h5>LỊCH SỬ DÒNG TIỀN</h5>
          </Col>
          <Col className='text-right'>
            <Button variant="info" type="button" onClick={_submitForm}>Tìm kiếm</Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container>
          <Col>
            <Row className='p-1'>
              <Col>
                <Row>
                  <Col md={3} className='text-right align-self-center'>
                    <Form.Label>Từ ngày</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      timeFormat={false}
                      onChange={_handleChangeFrom}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col md={3} className='text-right align-self-center'>
                    <Form.Label>Đến ngày</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      timeFormat={false}
                      onChange={_handleChangeTo}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col>
                <Row>
                  <Col md={3} className='text-right align-self-center'>
                    <Form.Label>Số điện thoại</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại của một người" />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col md={3} className='text-right align-self-center'>
                    <Form.Label>Ví</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Select value={wallet} onChange={_handleChangeWallet}>
                      <option value="main">Ví chính</option>
                      <option value="reward">Ví thưởng</option>
                    </Form.Select>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm)
